module.exports = __webpack_public_path__ + "static/media/img-background1.9e8aa976.jpg";